export default "https://cdn-static.gokick.com/assets/afaaccc9c40207d12945800ee9a4df41e308a977/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";